export default [
    {
        key: 'display',
        components: [
            {
                key: 'labelPosition',
                ignore: true,
            },
            {
                key: 'placeholder',
                ignore: true,
            },
            {
                key: 'label',
                label: 'Payment Methods label',
                tooltip: 'Set the label for the payment method options',
                defaultValue: 'Payment Methods',
            },
        ]
    },
];
